const initialState = {
  openProgress: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'OPENPROGRESS':
      const { openProgress } = action;
      return {
        ...state,
        openProgress,
      };
    default:
      return state;
  }
};

export const setOpenProgress = (openProgress) => ({
  type: 'OPENPROGRESS',
  openProgress,
});
